import React from 'react';

/** Empty-range illustration for the analytics screen. */
export function AnalyticsArt() {
  return (
    <svg className="an-art" viewBox="0 0 420 250" aria-hidden="true">
      <rect className="an-art__sky" width="420" height="250" rx="28" />
      <circle className="an-art__sun" cx="348" cy="46" r="16" />
      <circle className="an-art__cloud" cx="58" cy="52" r="10" />
      <circle className="an-art__cloud" cx="76" cy="46" r="14" />
      <path className="an-art__hill" d="M0 158c48-28 78 8 128-10 40-14 64 16 112-6 32-14 58 8 92-8 22-10 48 4 88-12v128H0z" />
      <path className="an-art__hill2" d="M0 196c62-24 92 14 150-4 46-14 72 16 170-12v70H0z" />
      <rect className="an-art__panel" x="78" y="78" width="264" height="124" rx="22" />
      <rect className="an-art__bar an-art__bar--a" x="104" y="132" width="20" height="46" rx="7" />
      <rect className="an-art__bar an-art__bar--b" x="136" y="114" width="20" height="64" rx="7" />
      <rect className="an-art__bar an-art__bar--c" x="168" y="98" width="20" height="80" rx="7" />
      <rect className="an-art__bar an-art__bar--d" x="200" y="122" width="20" height="56" rx="7" />
      <circle cx="292" cy="140" r="28" fill="none" stroke="var(--ml-info, #3b6cff)" strokeWidth="10" />
      <circle
        cx="292"
        cy="140"
        r="28"
        fill="none"
        stroke="#f5a524"
        strokeWidth="10"
        strokeDasharray="42 140"
        strokeLinecap="round"
      />
      <circle className="an-art__hole" cx="292" cy="140" r="15" />
      <path d="M164 62c-9 13-15 20-15 30a15 15 0 0 0 30 0c0-10-6-17-15-30z" fill="var(--ml-primary, #7c5cff)" />
      <circle cx="164" cy="90" r="4" fill="#fff" />
    </svg>
  );
}
